import React from 'react'
import PropTypes from 'prop-types'
import { Image, Navbar } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

export const Header = ({ logout, email }) => {
	return <Navbar collapseOnSelect>
		<Navbar.Header>
			<Navbar.Brand>
				<Image src="/img/logo.svg" className="pull-left" width='30' />
				<NavLink to="/home">Allocation Admin</NavLink>
			</Navbar.Brand>
			<Navbar.Toggle />
		</Navbar.Header>
		<Navbar.Collapse>
			<ul className="nav navbar-nav navbar-right">
				<li><NavLink to="/home">Home</NavLink></li>
				<li><NavLink to="/allocations">Allocations</NavLink></li>
				<li><NavLink to="/settings">Settings</NavLink></li>
				<li onClick={() => logout()}><a className='u-cursor--pointer'>Log out <span>({email})</span></a></li>
			</ul>
		</Navbar.Collapse>
	</Navbar>
}

Header.propTypes = {
	logout: PropTypes.func,
	email: PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js